import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mail-unsubscribe',
  templateUrl: './mail-unsubscribe.component.html',
  styleUrls: ['./mail-unsubscribe.component.scss']
})
export class MailUnsubscribeComponent {

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute
  ) { }

  unsubscribed: boolean = false;

  form = this.fb.group({
    many_messages: [false],
    never_sign_in: [false],
    not_relevant: [false],
    email_change: [false],
    spam: [false],
    other: [false],
    other_reason: ['', [Validators.maxLength(255)]],

    endereco_email: ['', [Validators.required]],
    tipo_email: ['', [Validators.required]],
    motivo: ['', [Validators.required]]
  });

  get otherChecked() {
    return this.form.get('other').value;
  }

  submit() {
    const body = {
      endereco_email: this.activatedRoute.snapshot.queryParams['email'],
      tipo_email: this.activatedRoute.snapshot.queryParams['type'],
      motivo: ''
    }

    if (this.form.get('many_messages').value)
      body.motivo += 'Recebe muitos e-mails';

    if (this.form.get('never_sign_in').value)
      body.motivo += '|Nunca se inscreveu';

    if (this.form.get('not_relevant').value)
      body.motivo += '|Não acha relevante';

    if (this.form.get('email_change').value)
      body.motivo += '|Trocou o e-mail';

    if (this.form.get('spam').value)
      body.motivo += '|Considera SPAM';

    if (this.form.get('other').value)
      body.motivo += '|' + this.form.get('other_reason').value;

    this.http.post(`${environment.apiUrl}/emails/unsubscribe`, body)
      .pipe(take(1))
      .subscribe(() => {
        this.unsubscribed = true;
      });
  }
}
